import React from 'react'
import PropTypes from 'prop-types'
import Turbolinks from 'turbolinks'
import { helpers, urlHelpers } from '../../helpers'

/**
* Displays a horizontal product card.
*/
class HorizontalProductCard extends React.Component {
  constructor(props) {
    super(props)

    this.getProductLink = this.getProductLink.bind(this)
    this.onClickHandler = this.onClickHandler.bind(this)

    this.renderPlaceholder = this.renderPlaceholder.bind(this)
    this.renderProductImage = this.renderProductImage.bind(this)
  }

  /**
  * Returns the link to the product. Returns the empty string if the product
  * doesn't have a slug.
  *
  * @returns {string}
  */
  getProductLink() {
    if (!this.props.product.slug) {
      return ''
    }
    const ref = this.props.listName ? `${this.props.listName}-${this.props.position}` : `detailed-card-${this.props.position}`

    return urlHelpers.addRef(`/p/${this.props.product.slug}`, ref)
  }

  /**
  * On click event handler for when a user clicks the prooduct card. Tracks
  * the product as having been clicked and then takes the user to the product's
  * destination.
  */
  onClickHandler(e) {
    e.preventDefault()
    let price = null


    let sku = null

    // Parse the price of the variant.
    if (this.props.product.variant && this.props.product.variant.price) {
      price = this.props.product.variant.price
    }

    // Parse the sku of the variant.
    if (this.props.product.variant && this.props.product.variant.sku) {
      sku = this.props.product.variant.sku
    } else {
      sku = this.props.product.sku || null
    }
    $.track('product click', {
      id: sku,
      name: this.props.product.name,
      brand: helpers.formatProducers(this.props.product.producers),
      category: this.props.product.variant ? this.props.product.variant.oracle_department_name : null,
      variant: this.props.product.variant ? this.props.product.variant.options_text_analytics : null,
      position: this.props.position,
      price,
    }, this.props.listName, () => {
      Turbolinks.visit(this.getProductLink())
    })
  }

  /**
  * Renders a placeholder of a detailed product card.
  */
  renderPlaceholder() {
    return (
      <a className="horizontal-product-card is-placeholder">
        <figure />
        <div className="card-content">
          <div className="product-details">
            <div className="product-name" />
            <div className="producer" />
          </div>
        </div>
      </a>
    )
  }

  /**
  * Renders the product image.
  */
  renderProductImage() {
    // For the image use either the override image or the default display image.
    let image = {}

    if (this.props.product.image) {
      image = this.props.product.image
    } else if (this.props.product.display_image_url) {
      image = {
        url: this.props.product.display_image_url,
      }
    }

    return (
      <figure>
        { this.props.loading ? false : (
          <img
            data-original={image.url || ''}
            data-fallback-text={this.props.product.name || ''}
            data-position={this.props.position}
            alt={image.alt || this.props.product.name || ''}
            className="is-lazy fade-in has-drop-shadow"
          />
        ) }
      </figure>
    )
  }

  render() {
    if (this.props.loading) {
      return this.renderPlaceholder()
    }

    return (
      <a
        href={this.getProductLink()}
        aria-label={this.props.product.name}
        className="horizontal-product-card is-loaded"
        onClick={this.onClickHandler}
      >
        { this.renderProductImage() }
        <div className="card-content">
          <div className="product-details">
            <div className="product-name">{ this.props.product.name }</div>
            <div className="producer">{ helpers.formatProducers(this.props.product.producers) }</div>
          </div>
        </div>
      </a>
    )
  }
}

HorizontalProductCard.defaultProps = {
  product: {},
  position: 0,
  listName: '',
  loading: false,
}

HorizontalProductCard.propTypes = {
  product: PropTypes.object,
  position: PropTypes.number,
  listName: PropTypes.string,
  loading: PropTypes.bool,
}

export default HorizontalProductCard
